module.exports = __webpack_public_path__ + "static/2-061864e1e74edce68093e9116a2c1d62.png";